import React from "react";
import { Helmet } from "react-helmet-async";
import { useParams } from "react-router-dom";

import Section1 from "../includes/JobDetails/Section1";
import { JOBS } from "../includes/Careers/jobsData";

const JobDetails = ({ devUrl }) => {
  const { jobId } = useParams();
  const job = JOBS.find((j) => j.id === jobId);
  const title = job ? job.title : "Role Not Found";
  const description = job
    ? job.summary
    : "The role you're looking for is no longer open or doesn't exist.";

  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        {job && (
          <link
            rel="canonical"
            href={`https://www.exddigital.com/careers/${job.id}`}
          />
        )}
        <meta property="og:title" content={`${title} | ExD Digital Careers`} />
        <meta property="og:description" content={description} />
        <meta property="og:type" content="website" />
      </Helmet>
      <main className="job-details-main">
        <article className="job-details">
          <Section1 url={devUrl} />
        </article>
      </main>
    </>
  );
};

export default React.memo(JobDetails);
